import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-sowhatbuy-card-basic.js';

const DEFAULT_IMAGE =
  'https://cdn.skyfastimg.com/images/2026/07/01/image-6a4480b1bc2f3fbfcc1c8eb5.webp?w=1000&h=50&q=80';

const boxItemHtml = text => `
  <li class="sowhatbuy-card-basic__box-item" data-attribute="sowhatbuy-card-basic__box-item">${text}</li>
`;

const contentHtml = `
  <div
    class="sowhatbuy-card-basic container"
    data-attribute="sowhatbuy-card-basic-content"
    data-image-position="left"
    data-gap="40"
    style="--section-gap: 40px;"
  >
    <div class="sowhatbuy-card-basic__image-wrap" data-attribute="sowhatbuy-card-basic__image-wrap">
      <img
        loading="lazy"
        data-attribute="sowhatbuy-card-basic__image"
        src="${DEFAULT_IMAGE}"
        alt=""
      />
    </div>
    <div class="sowhatbuy-card-basic__content" data-attribute="sowhatbuy-card-basic__content">
      <div class="sowhatbuy-card-basic__specification" data-attribute="sowhatbuy-card-basic__specification">
        <h2>
          <span style="color: #d35400; font-size: 32px"><strong>Specification</strong></span>
        </h2>
        <p><strong>Colors:</strong> Gray, Black</p>
        <p><strong>Material:</strong> ABS + Acrylic Lens</p>
        <p><strong>Magnification:</strong> 4X</p>
        <p><strong>Lens:</strong> 108 × 63 mm</p>
        <p><strong>Dimensions:</strong> Folded 130 × 113 × 20 mm / Unfolded 270 × 113 × 20 mm</p>
        <p><strong>Light:</strong> 10 LEDs, 3 Brightness Levels</p>
        <p><strong>Power:</strong> USB Rechargeable with Battery Indicator</p>
        <p><strong>Battery:</strong> 650 mAh, 3.7V</p>
      </div>
      <div class="sowhatbuy-card-basic__box" data-attribute="sowhatbuy-card-basic__box">
        <div
          class="sowhatbuy-card-basic__box-title"
          data-attribute="sowhatbuy-card-basic__box-title"
          data-background="#d35400"
          data-text-color="#ffffff"
          style="background-color: #d35400; color: #ffffff;"
        >
          WHAT'S IN THE BOX
        </div>
        <ul class="sowhatbuy-card-basic__box-list" data-attribute="sowhatbuy-card-basic__box-list">
          ${boxItemHtml('Magnifier × 1')}
          ${boxItemHtml('Fabric Pouch × 1')}
          ${boxItemHtml('Lens Cleaning Cloth × 1')}
          ${boxItemHtml('USB-C Charging Cable × 1')}
          ${boxItemHtml('User Manual × 1')}
        </ul>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#F8FAF5',
  topPadding: true,
  bottomPadding: true,
});
